var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.774 4.16s-.205-1.465-.834-2.11c-.798-.847-1.693-.85-2.103-.9-2.936-.215-7.34-.215-7.34-.215h-.01s-4.404 0-7.34.215c-.411.05-1.305.053-2.104.9C.414 2.695.21 4.16.21 4.16S0 5.88 0 7.6v1.613c0 1.72.21 3.44.21 3.44s.204 1.464.833 2.11c.799.846 1.847.82 2.314.908 1.68.164 7.135.214 7.135.214s4.409-.007 7.345-.222c.41-.05 1.305-.054 2.103-.9.629-.646.834-2.11.834-2.11s.21-1.72.21-3.44V7.6c0-1.72-.21-3.44-.21-3.44Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.325 11.167V5.195l5.67 2.996z"
  }))));
};

export default SvgYoutube;